
import Base from "@/Base";
import { Component, Prop, PropSync } from "vue-property-decorator";
import { ProductType } from "@/enum/product/ProductType";
import { ModalLectureTableConfig } from "@/components/product/modal/model/modalConfig/ModalLectureTableConfig";
import { ModalTicketTableConfig } from "@/components/product/modal/model/modalConfig/ModalTicketTableConfig";
import { ModalSpecialTrackTableConfig } from "@/components/product/modal/model/modalConfig/ModalSpecialTrackTableConfig";
import { ModalSubscribeTableConfig } from "@/components/product/modal/model/modalConfig/ModalSubscribeTableConfig";
import PageDataModel from "@/service/model/common/PageDataModel";
import { lectureService } from "@/service/api/LectureService";
import { ticketService } from "@/service/api/TicketService";
import { subscribeService } from "@/service/api/SubscribeService";
import { productService } from "@/service/api/ProductService";

@Component
export default class SelectProductModal extends Base {
  @PropSync("modalVisible")
  private syncVisible!: boolean;
  @Prop({ default: "" })
  private productType!: string;
  @PropSync("productMapId")
  private syncMapId!: number;

  private keyword = "";
  private isLoading = false;
  private isCheckBoxFlag = false;
  private page = 1;

  private mounted() {
    this.getProductData(this.productType);
  }

  private productTypeToTableData: PageData<
    InquiredLectureData | Ticket | Subscribe | ProductSpecialTrack
  > = new PageDataModel();

  private productTypeToTableConfig: { [key: string]: any } = {
    [ProductType.LECTURE]: ModalLectureTableConfig,
    [ProductType.TICKET]: ModalTicketTableConfig,
    [ProductType.SPECIAL_TRACK_CURRICULUM]: ModalSpecialTrackTableConfig,
    [ProductType.SUBSCRIBE]: ModalSubscribeTableConfig
  };

  private getProductData(type: string) {
    if (type === ProductType.LECTURE) {
      lectureService
        .retrieveLectureList(this.page, 5, "LECTURE_TITLE", this.keyword)
        .subscribe((data: PageData<InquiredLectureData>) => {
          this.productTypeToTableData = data;
          this.isLoading = true;
        });
    } else if (type === ProductType.TICKET) {
      ticketService
        .retrieveTicketList(this.page, 5, undefined, undefined, this.keyword)
        .subscribe((data: PageData<Ticket>) => {
          this.productTypeToTableData = data;
          this.isLoading = true;
        });
    } else if (type === ProductType.SUBSCRIBE) {
      subscribeService
        .retrieveSubscribeList(this.page, 5)
        .subscribe((data: PageData<Subscribe>) => {
          this.productTypeToTableData = data;
          this.isLoading = true;
        });
    } else if (type === ProductType.SPECIAL_TRACK_CURRICULUM) {
      productService
        .retrieveSpecialTrackList(this.page, 5, this.keyword)
        .subscribe((data: PageData<ProductSpecialTrack>) => {
          this.productTypeToTableData = data;
          this.isLoading = true;
        });
    }
  }

  private onSubmitContent(): void {
    this.syncVisible = false;
  }

  private onClose(): void {
    this.syncVisible = false;
  }

  private onSearch(): void {
    this.page = 1;
    this.getProductData(this.productType);
  }

  private onChangePage(page: number): void {
    this.page = page;
    this.getProductData(this.productType);
  }

  private onClickChoice(id: number): void {
    if (this.syncMapId !== id) {
      this.isCheckBoxFlag = true;
      this.syncMapId = id;
    } else {
      this.isCheckBoxFlag = false;
      this.syncMapId = 0;
    }
  }

  private inventedRowKey(record: Product, index: number): string {
    return index + "";
  }
}
